import React from "react";
import {
	CarouselProvider,
	Slider,
	ButtonBack,
	ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

export default function Carousel({ children, slidesTotal }) {
	const total = slidesTotal;
	return (
		<div className="max-w-full">
			<CarouselProvider
				className="max-w-full"
				// naturalSlideWidth={100}
				isIntrinsicHeight={true}
				totalSlides={total}
				visibleSlides={1}
				step={1}
				infinite={true}
			>
				<div className="max-w-full relative flex items-center sm:px-4">
					<ButtonBack
						role="button"
						aria-label="slide backward"
						className="absolute z-30 left-0 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer"
						id="prev"
					>
						<svg
							width={8}
							height={14}
							viewBox="0 0 8 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M7 1L1 7L7 13"
								stroke="black"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</ButtonBack>

					<div className="max-w-full w-full overflow-hidden">
						<Slider>
							<div
								id="slider"
								className="w-full bg-white transition ease-out duration-700"
							>
								{children}
							</div>
						</Slider>
					</div>

					<ButtonNext
						role="button"
						aria-label="slide forward"
						className="absolute z-30 right-0 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
						id="next"
					>
						<svg
							width={8}
							height={14}
							viewBox="0 0 8 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1 1L7 7L1 13"
								stroke="black"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</ButtonNext>
				</div>
			</CarouselProvider>
		</div>
	);
}
